(() => {
  function setup(scope) {
    if (!scope || scope.aeModelCleanup) return;
    const title = scope.querySelector('.product__title h1');
    title?.classList.add('titlekg');
    let frame = 0;
    let stopped = false;

    function arrange() {
      frame = 0;
      if (stopped) return;
      const nativePicker = scope.querySelector('variant-selects');
      let fragrance = scope.querySelector('.pplr-dropdown:has(select.pplr_select)');
      if (!fragrance && nativePicker) {
        fragrance = nativePicker.closest('.ae-native-fragrance');
        if (!fragrance) {
          fragrance = document.createElement('div');
          fragrance.className = 'ae-auto-fragrance ae-native-fragrance';
          nativePicker.before(fragrance);
          fragrance.appendChild(nativePicker);
        }
      }
      const quantity = scope.querySelector('.product-form__quantity');
      const input = quantity?.querySelector('.quantity__input');
      const guide = scope.querySelector('.ae-price-guide');
      const summary = scope.querySelector('.ae-quantity-summary');
      const progress = scope.querySelector('.ae-quantity-progress');
      const buttonText = scope.querySelector('.product-form__buttons button[name="add"] > span');
      if (!fragrance || !quantity || !input || !guide || !summary || !progress || !buttonText || !window.AirEssenceQuantity) return;

      let controls = quantity.querySelector('.quantite-container');
      if (!controls) {
        controls = document.createElement('div');
        controls.className = 'quantite-container';
        controls.appendChild(input.closest('quantity-input'));
        const helper = document.createElement('p');
        helper.className = 'paraquant';
        controls.appendChild(helper);
        quantity.appendChild(controls);
      }
      quantity.prepend(guide);
      quantity.append(summary, progress);
      fragrance.appendChild(quantity);

      const select = fragrance.querySelector('select');
      const label = fragrance.querySelector('label.pplrlabel');
      if (label) {
        select.id ||= `AeModelFragrance-${scope.id}`;
        label.htmlFor = select.id;
      }
      window.AirEssenceQuantity.connect({
        input,
        priceText: controls.querySelector('.paraquant'),
        buttonText,
        buttonLabel: buttonText.textContent.trim()
      });
      observer.disconnect();
    }

    function schedule() {
      if (!frame && !stopped) frame = requestAnimationFrame(arrange);
    }

    function destroy() {
      stopped = true;
      observer.disconnect();
      if (frame) cancelAnimationFrame(frame);
      document.removeEventListener('shopify:section:unload', unload);
      delete scope.aeModelCleanup;
    }

    function unload(event) {
      if (event.target.contains(scope)) destroy();
    }

    const observer = new MutationObserver(schedule);
    observer.observe(scope, { childList: true, subtree: true });
    document.addEventListener('shopify:section:unload', unload);
    scope.aeModelCleanup = destroy;
    arrange();
  }

  function boot(container = document) {
    container.querySelectorAll('product-info').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();

